import { useSelector, useDispatch } from 'react-redux';
import { addFavorites, deleteFavorites } from '@common/Favorites/actions/favoritesActions';
import { favoriteProductsData } from '@common/Favorites/selectors';

const useFavorites = () => {
    const dispatch = useDispatch();
    const { requestQueue, variantIds } = useSelector(favoriteProductsData);

    const isFavorite = variantId => variantIds.includes(Number(variantId));

    const isInQueue = variantId => requestQueue.includes(Number(variantId));

    const addToFavorites = (variantId, itemsParameters, interactionOrigin) => {
        if (!isInQueue()) {
            dispatch(addFavorites(
                Number(variantId),
                itemsParameters,
                interactionOrigin
            ));
        }
    };

    const removeFromFavorites = (variantId) => {
        if (!isInQueue()) {
            dispatch(deleteFavorites([Number(variantId)]));
        }
    };

    return { isFavorite, addToFavorites, removeFromFavorites };
};

export default useFavorites;
